import React from 'react';
import {BrowserRouter, Route, Switch} from 'react-router-dom';
import Dashboard from '../pages/Dashboard';
import EditUsers from '../features/users/pages/NewUser';
import UserRoles from "../features/admin/components/roles-management/ViewRoles";
import Beneficiaries from "../features/admin/components/roles-management/ViewBeneficiaries.jsx";
import BankingDetails from "../features/admin/components/roles-management/ViewBankingDetails.jsx";
import Signin from '../features/auth/pages/Signin';
import Signup from '../features/auth/pages/Signup';
import CreateNew from '../features/auth/pages/CreateNew';
import RegisterPolicyholder from '../features/auth/pages/RegisterPolicyholder';
import GuestPayment from '../features/payments/pages/GuestPayment';
import LoanApplication from "../features/loans/pages/NewLoan.jsx";
import {AuthProvider} from '../features/auth/components/use-auth';
import {RequireAuth} from '../features/auth/components/require-auth';
import Custom404 from '../pages/NotFound';
import ApprovePolicyPage from "../features/policies/pages/approvepolicy/ApprovePolicyPage";
import ApproveLoansPage from "../features/loans/pages/approval/ApproveLoansPage";
import BeneficiaryRequestsPage from "../features/policies/pages/beneficiary_requests/BeneficiaryRequestsPage";
import Reset from '../features/auth/pages/Reset';
import ResetFrom from '../features/auth/pages/ResetPassword.jsx';
import Landing from '../features/auth/pages/Landing';
import ManageProducts from '../features/admin/pages/products/ManageProducts.jsx'
import ManageBanks from '../features/admin/pages/products/ManageBanks.jsx'
import ManageAds from '../features/admin/pages/ads/ManageAds'
import PaymentReport from '../features/reports/pages/payments/PaymentsReport'
import CustomersProfileReport from '../features/reports/pages/customers/CustomersProfileReport';
import EmployeesProfileReport from '../features/reports/pages/employees/EmployeesProfileReport';
import AllUsersProfileReport from '../features/reports/pages/all-users/AllUsersProfileReport';
import ManagePolicy from "../features/policies/pages/ManagePolicy"
import ManageLoans from "../features/loans/pages/Loans"
import Payments from '../features/payments/pages/Payments';
import ApplyPolicy from "../features/policies/pages/ApplyPolicy"
import TermsAndConditions from "../pages/TermsAndConditions"
import CorperateReceiptsReport from "../features/payments/pages/cooperate_receipts/AllCorporateReceipts";
import AgentReports from "../features/reports/pages/agents/AgentReports";
import DeviceReports from "../features/reports/pages/devices/DeviceReports";
import ClaimsDashboard from "../features/claims/pages/ClaimsDashboard";
import CreateClaim from "../features/claims/pages/CreateClaim";
import ViewClaim from "../features/claims/pages/ViewClaim";
import AdminClaimsList from "../features/claims/pages/AdminClaimsList";

const Router = () => {
    return (
        <AuthProvider >
            <BrowserRouter >
                {/* <BrowserRouter> */}
                <div id="main-wrapper">
                    <Switch>
                        <Route path='/signin' component={Signin} />
                        <Route path='/signup' component={Signup} />
                        <Route path='/landing' component={Landing} />
                        <Route path='/create-new-account' component={CreateNew} />
                        <Route path='/register-policyholder' component={RegisterPolicyholder} />
                        <Route path='/pay-guest' component={GuestPayment} />

                        <Route path='/' exact >
                            <RequireAuth><Dashboard /></RequireAuth>
                        </Route>
                        <Route path="/edit-users">
                            <RequireAuth><EditUsers /></RequireAuth>
                        </Route>
                        <Route path="/edit-user-roles"  >
                            <RequireAuth><UserRoles /></RequireAuth>
                        </Route>
                        <Route path="/beneficiaries"  >
                            <RequireAuth><Beneficiaries /></RequireAuth>
                        </Route>
                        <Route path="/banking-details">
                            <RequireAuth><BankingDetails/></RequireAuth>
                        </Route>
                        {
                            /*
                                CUSTOMER FUNCTIONALITY ROUTES
                            */
                        }
                        <Route path='/manage-policy'>
                            <RequireAuth><ManagePolicy /></RequireAuth>
                        </Route>
                        <Route path='/apply-policy'>
                            <RequireAuth><ApplyPolicy /></RequireAuth>
                        </Route>
                        <Route path='/loans/new' >
                            <RequireAuth><LoanApplication /></RequireAuth>
                        </Route>

                        <Route path='/loans' >
                            <RequireAuth><ManageLoans /></RequireAuth>
                        </Route>
                        <Route path='/payments'>
                            <RequireAuth><Payments /></RequireAuth>
                        </Route>
                        <Route path='/profile' >
                            <RequireAuth><ManagePolicy /></RequireAuth>
                        </Route>

                        {/* CLAIMS MANAGEMENT */}
                        <Route path='/claims/create'>
                            <RequireAuth><CreateClaim /></RequireAuth>
                        </Route>
                        <Route path='/claims/view/:referenceNumber'>
                            <RequireAuth><ViewClaim /></RequireAuth>
                        </Route>
                        <Route path='/claims/view-all' exact>
                            <RequireAuth><AdminClaimsList /></RequireAuth>
                        </Route>
                        <Route path='/claims' exact>
                            <RequireAuth><ClaimsDashboard /></RequireAuth>
                        </Route>

                        {/* PRODUCT MANAGEMENT */} 

                        <Route path='/list/products' >
                            <RequireAuth><ManageProducts /></RequireAuth>
                        </Route>

                        {/* PRODUCT MANAGEMENT */} 

                        <Route path='/list/banks' >
                            <RequireAuth><ManageBanks /></RequireAuth>
                        </Route>

                        {/* ADS MANAGEMENT */} 

                        <Route path='/manage/ads' >
                            <RequireAuth><ManageAds /></RequireAuth>
                        </Route>

                        {/* 
                            EMPLOYEE FUNCTIONALITY ROUTES
                        */}

                        <Route path="/policy/approval" >
                            <RequireAuth><ApprovePolicyPage /></RequireAuth>
                        </Route>
                        <Route path="/loans/approval">
                            <RequireAuth><ApproveLoansPage /></RequireAuth>
                        </Route>
                        <Route path="/policy/beneficiary-requests">
                            <RequireAuth><BeneficiaryRequestsPage /></RequireAuth>
                        </Route>


                        {/*                         
                            REPORT ROUTES
                        */}

                        <Route path="/customers-profile-report" >
                            <RequireAuth><CustomersProfileReport /></RequireAuth>
                        </Route>
                        <Route path="/payments-report" >
                            <RequireAuth><PaymentReport /></RequireAuth>
                        </Route>
                        <Route path="/employee-profile-report" >
                            <RequireAuth><EmployeesProfileReport /></RequireAuth>
                        </Route>
                        <Route path="/users-profile-report" >
                            <RequireAuth><AllUsersProfileReport /></RequireAuth>
                        </Route>
                        <Route path="/agents-payments-report" >
                            <RequireAuth><AgentReports /></RequireAuth>
                        </Route>
                        <Route path="/device-payments-report" >
                            <RequireAuth><DeviceReports /></RequireAuth>
                        </Route>
                        <Route path="/termsandconditions" >
                            <RequireAuth><TermsAndConditions /></RequireAuth>
                        </Route>

                        <Route path='/reset' component={Reset} />
                        <Route path='/set-password/:userId/:otp' component={ResetFrom} />


                        {/*
                            CORPORATE RECEIPTS ROUTES
                        */}

                        <Route path="/corporate-receipts/view" >
                            <RequireAuth><CorperateReceiptsReport /></RequireAuth>
                        </Route>


                        {/* IF ROUTE IS NOT FOUND */}

                        <Route path='*' component={Custom404} />

                    </Switch>
                </div>
            </BrowserRouter>
        </AuthProvider>
    );
};

export default Router;